import crypto from 'crypto'

function isWeixin() {
	let user = navigator.userAgent.toLowerCase()
	if (user.match(/MicroMessenger/i) == "micromessenger") {
		return true
	} else {
		return false
	}
}
function stringify(data) {
	const formData = new FormData()
	for (const key in data) {
		// eslint-disable-next-line no-prototype-builtins
		if (data.hasOwnProperty(key)) {
			if (data[key]) {
				if (data[key].constructor === Array) {
					if (data[key][0]) {
						if (data[key][0].constructor === Object) {
							formData.append(key, JSON.stringify(data[key]))
						} else {
							data[key].forEach((item, index) => {
								formData.append(key + `[${index}]`, item)
							})
						}
					} else {
						formData.append(key + '[]', '')
					}
				} else if (data[key].constructor === Object) {
					formData.append(key, JSON.stringify(data[key]))
				} else {
					formData.append(key, data[key])
				}
			} else {
				if (data[key] === 0) {
					formData.append(key, 0)
				} else {
					formData.append(key, '')
				}
			}
		}
	}
	return formData
}

function getSearch(hash, searchKey) {
	let search = ''
	if (hash) {
		let index = location.hash.indexOf('?')
		if (index > -1) {
			search = location.hash.substr(index)
		}
	} else
		search = location.search
	const obj = {}
	if (search.indexOf("?") == 0) {
		const arr = search.substr(1).split("&")
		arr.map(item => {
			item = item.split('=')
			if (item[0])
				obj[item[0]] = item[1]
		})
	}
	if (searchKey)
		return obj[searchKey]
	return obj
}

function getCookie(key) {
	const cookieObj = {}
	document.cookie.replace(/\s/g, '').split(';').map(item =>
		item.split('=')
	).map(item => {
		if (item.length >= 2 && item[0] !== '')
			cookieObj[item[0]] = item.splice(1).join('=')
	})
	if (key)
		return cookieObj[key]
	return cookieObj
}

function getRowHTML(obj) {
	if (Object.prototype.toString.call(obj) !== '[object Object]')
		return ''
	let message = ''
	for (let key in obj) {
		const item = {
			tag: obj[key] && obj[key].tag || 'div',
			content: obj[key] && obj[key].content || obj[key],
			class: obj[key] && obj[key].class || '',
			attr: obj[key] && obj[key].attr || '',
		}
		message += `
			<div class="flex-row" style="min-height: 2rem;">
				<div class="row-key pl-0 text-secondary font-weight-bold" style="flex-basis: 6rem"> 
					${key}
				</div>
				<${item.tag} 
					class="row-value ${item.class}" 
					${item.attr}>
					${item.content} 
				</${item.tag}>
			</div>`
	}
	return message
}

function randString(len) {
	len = len || 32
	const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkm!@np?rst_wx?yz2345678'
	/** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*** */
	const maxPos = $chars.length
	let pwd = ''
	for (let i = 0; i < len; i++) {
		pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
	}
	return pwd
}
// app_id,secret,grant_type,timestamp
function getSignature(app_id, secret, grant_type, timestamp) {
	// 将args参数首字母按ascii排序?拼接成字符串
	let args = [
		'app_id=' + app_id,
		'grant_type=' + grant_type,
		'secret=' + secret,
		'timestamp=' + timestamp
	]
	let data = ''
	args.sort()
	args.forEach((e, index) => {
		if (index < args.length - 1)
			data += `${e}&`
		else
			data += e
	})
	const hmac = crypto.createHmac('sha256', secret);
	hmac.update(data);
	const hmacResult = hmac.digest('hex');
	// 字母大写
	return hmacResult.toUpperCase();;
}
// 将金额转为大写
function upperMoney(account) {
	const money = account.toFixed(2); // 金额保留两位小数
	// 汉字的数字
	const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	// 基本单位
	const cnIntRadice = ['', '拾', '佰', '仟'];
	// 对应整数部分扩展单位
	const cnIntUnits = ['', '万', '亿', '兆'];
	// 对应小数部分单位
	const cnDecUnits = ['角', '分', '毫', '厘'];
	// 整数金额时后面跟的字符
	const cnInteger = '整';
	// 整型完以后的单位
	const cnIntLast = '元';
	// 最大处理的数字
	const maxNum = 9999999999999.99;
	// 金额整数部分
	let integerNum = '';
	// 金额小数部分
	let decimalNum = '';
	// 输出的中文金额字符串
	let chineseStr = '';
	// 分离金额后用的数组，预定义
	let parts;
	if (money >= maxNum) {
	  // 超出最大处理数字
	  return '';
	}
	if (money === 0) {
	  chineseStr = cnNums[0] + cnIntLast + cnInteger;
	  return chineseStr;
	}
	// 转换为字符串
	let moneyStr = money.toString();
	if (money < 0) {
	  // 负数判断
	  moneyStr = moneyStr.slice(1);
	}
	if (moneyStr.indexOf('.') === -1) {
	  integerNum = moneyStr;
	  decimalNum = '';
	} else {
	  parts = moneyStr.split('.');
	  integerNum = parts[0];
	  decimalNum = parts[1];
	}
	// 获取整型部分转换
	if (parseInt(integerNum, 10) > 0) {
	  let zeroCount = 0;
	  const IntLen = integerNum.length;
	  for (let i = 0; i < IntLen; i += 1) {
		const n = integerNum.substring(i, i + 1);
		const p = IntLen - i - 1;
		const q = p / 4;
		const m = p % 4;
		if (n === '0') {
		  zeroCount += 1;
		} else {
		  if (zeroCount > 0) {
			chineseStr += cnNums[0];
		  }
		  // 归零
		  zeroCount = 0;
		  chineseStr += cnNums[parseInt(n, 10)] + cnIntRadice[m];
		}
		if (m === 0 && zeroCount < 4) {
		  chineseStr += cnIntUnits[q];
		}
	  }
	  chineseStr += cnIntLast;
	}
	// 小数部分
	if (decimalNum !== '') {
	  const decLen = decimalNum.length;
	  for (let i = 0; i < decLen; i += 1) {
		const n = decimalNum.substring(i, i + 1);
		if (n !== '0') {
		  chineseStr += cnNums[Number(n)] + cnDecUnits[i];
		}
	  }
	}
	if (chineseStr === '') {
	  chineseStr += cnNums[0] + cnIntLast + cnInteger;
	} else if (decimalNum === '') {
	  chineseStr += cnInteger;
	}
	return (money < 0 ? '负' : '') + chineseStr;
  }
// 输出：一亿二千三百四十五万六千七百八十九

// 加密函数
function encryptAES256(data, key, ranStr) {
	const cipher = crypto.createCipheriv('aes-256-cbc', key, ranStr);
	let encrypted = cipher.update(data, 'utf8', 'base64');
	encrypted += cipher.final('base64');
	return encrypted;
}


export {
	stringify,
	isWeixin,
	getSearch,
	getCookie,
	getRowHTML,
	randString,
	getSignature,
	encryptAES256,
	upperMoney
}
